export default class CreateCourseCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createCourseVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    const texts = GlobalConfig.appTexts
    const post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId,
      name: currentUser.name
    }

    createCourseVm.isEditing = ($stateParams.courseId) ? true : false

    // VARIABLES
    createCourseVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createCourseVm.rangeType = GlobalConfig.periods.rangeType
    createCourseVm.workplanTeacherActivityId = null
    createCourseVm.createOrEdit = 'Crear'
    createCourseVm.textCreateOrEdit = texts.saved
    createCourseVm.createOrEditMV = texts.createDialog
    createCourseVm.typePeriod = []
    createCourseVm.periodsArray = []
    createCourseVm.selectedTypePeriod = {}
    createCourseVm.isTouchedPeriods = false
    createCourseVm.startDate = null
    createCourseVm.endDate = null
    createCourseVm.minStartDate = moment().toDate()
    createCourseVm.minEndDate = new Date()
    createCourseVm.listEntity = []
    createCourseVm.listInstitutions = []
    createCourseVm.plannedHours = 0
    createCourseVm.disableSaveButton = false
    createCourseVm.isFeedback = currentUser.isFeedback
    createCourseVm.dt_start = $cookies.get('wp_start')
    createCourseVm.dt_end = $cookies.get('wp_end')

    // METHODS
    createCourseVm.hasError = hasError
    createCourseVm.showErrorMessages = showErrorMessages
    createCourseVm.addCourse = addCourse
    createCourseVm.validateForm = validateForm
    createCourseVm.validateCheklistPeriods = validateCheklistPeriods
    createCourseVm.funSelectedPeriod = funSelectedPeriod
    createCourseVm.startDateChange = startDateChange
    createCourseVm.confirmCourseAction = confirmCourseAction
    createCourseVm.searchInstitution = searchInstitution
    createCourseVm.changeInstitution = changeInstitution
    createCourseVm.changeDepartament = changeDepartament
    createCourseVm.addOrEditcourses = addOrEditcourses
    createCourseVm.close = close
    createCourseVm.changeTypeInstitution = changeTypeInstitution

    createCourseVm.updateRangeType = (val) => {
      createCourseVm.rangeType = val
      createCourseVm.periodsArray = []
      createCourseVm.startDate = null
      createCourseVm.endDate = null
    }
    createCourseVm.updateRangeData = (val) => {
      createCourseVm.periodsArray = val['periods']
      createCourseVm.startDate = val['dates'][0]
      createCourseVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createCourseVm.isEditing) {
        createCourseVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createCourseVm.activityTypeId = GlobalConfig.activityTypeId.teacherDevelopment
        createCourseVm.createOrEdit = 'Editar'
        createCourseVm.createOrEditMV = texts.editDialog
        createCourseVm.textCreateOrEdit = texts.modified
        getDataCourses()
      }

      WorkPlanSrv.getDataCoursesList.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(dataReturn)
        }
      )

      listInstitutions()
    }

    function loadData (data) {
      createCourseVm.cities = data.cities
      createCourseVm.countries = data.countries
      createCourseVm.state = data.states
      createCourseVm.listsTypeInstitution = data.listsTypeInstitution.items
      createCourseVm.typePeriod = data.listPeriods
      createCourseVm.listEntity = data.listsEntity.items
      createCourseVm.listModality = data.listsModality.items
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function addCourse (isExecution) {
      let origin = 1
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return form.$invalid ||
             createCourseVm.validateCheklistPeriods()
    }

    function getDataCourses () {
      let post = {
        workplanTeacherActivityId: parseInt(createCourseVm.workplanTeacherActivityId),
        activityTypeId: parseInt(createCourseVm.activityTypeId)
      }
      WorkPlanSrv.getActivityDetailTeachingStaff.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createCourseVm.course = dataReturn.data
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (course) {
      createCourseVm.country = course.countryId
      createCourseVm.departament = course.stateId
      createCourseVm.city = course.cityId
      createCourseVm.title = course.name
      createCourseVm.institutionType = course.instituteTypeId
      createCourseVm.searchText = course.nameInstitute
      createCourseVm.entityType = course.entityId
      createCourseVm.level = course.level
      createCourseVm.modality = course.modalityId
      createCourseVm.program = course.nameStudy
      createCourseVm.courseDescription = course.description
      createCourseVm.rangeType = course.timeRangeTypeId
      createCourseVm.dt_start = moment(course.startDate, 'YYYY-MM-DD').toDate()
      createCourseVm.dt_end = moment(course.endDate, 'YYYY-MM-DD').toDate()
      createCourseVm.plannedHours = course.hoursPlanned
      createCourseVm.periodsArray = []
      createCourseVm.selectedTypePeriod = {}

      if (course.periodId) {
        var splits = course.periodId.split(',')
        createCourseVm.startDate = null
        createCourseVm.endDate = null
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]

          if (parseInt(createCourseVm.rangeType) == GlobalConfig.periods.rangeType) {
            createCourseVm.periodsArray.push(parseInt(valor))
            createCourseVm.selectedTypePeriod[valor] = true
          }
        }
      }

      if (course.startDate) {
        var startDateNew = moment(course.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createCourseVm.minStartDate = moment(course.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createCourseVm.isEditing = true
    }

    function confirmCourseAction () {
      let header = {
        createOrEdit: createCourseVm.createOrEditMV,
        textCreateOrEdit: createCourseVm.textCreateOrEdit,
        itemName: createCourseVm.title,
        nameModal: texts.modalTypeName.teachingDev,
        modalType: texts.modalTypeId.teachingDev
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header)
    }

    function validateCheklistPeriods () {
      return (createCourseVm.rangeType == 1 ? createCourseVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createCourseVm.periodsArray.includes(period.periodId)) {
          createCourseVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createCourseVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createCourseVm.periodsArray.splice(index, 1)
        }
      }
      createCourseVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createCourseVm.startDate)
      createCourseVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    // AUTOCOMPLETE
    function listInstitutions () {
      WorkPlanSrv.getInstitutionCountry.getList().$promise.then(
          dataReturn => {
            if (dataReturn.status) {
              createCourseVm.listInstitutions = dataReturn.institutionCountries
            } else {
              console.log('Comunications problem')
            }
          },
        data => {
          console.log(listInstitutions)
        }
      )
    }

    function searchInstitution (searchText, type) {
      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'nameInstitution'
      createCourseVm.listInstitutions.forEach((list) => {
        if (list.idInstitution === type) {
          if (list[attr] && list[attr].match(matcher)) {
            arr.push(list)
          }
        }
      })
      return arr
    }

    function changeInstitution (courses) {
      if (courses) {
        createCourseVm.country = courses.countryId
        createCourseVm.departament = courses.stateId
        createCourseVm.city = courses.cityId
      } else {
        createCourseVm.country = null
        createCourseVm.departament = null
        createCourseVm.city = null
      }
    }

    function changeDepartament (departament) {
      if (!departament) {
        createCourseVm.city = null
        createCourseVm.departament = null
      }
    }

    function createJson (origin) {
      createCourseVm.disableSaveButton = true
      var courses = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        activityId: GlobalConfig.minorActivityId.courses,
        name: createCourseVm.title,
        entityId: createCourseVm.entityType,
        level: createCourseVm.level,
        modalityId: createCourseVm.modality,
        instituteTypeId: createCourseVm.institutionType,
        courseTypeId: GlobalConfig.courseType.courseExternal,
        nameInstitute: createCourseVm.searchText,
        cityId: createCourseVm.city,
        program: createCourseVm.program,
        description: createCourseVm.courseDescription,
        hoursPlanning: createCourseVm.plannedHours,
        timeRangeTypeId: createCourseVm.rangeType,
        origin: origin,
        isFeedbackActivity: createCourseVm.isFeedback
      }

      if (createCourseVm.isEditing) {
        courses.workplanTeacherActivityId = createCourseVm.workplanTeacherActivityId
      }

      if (createCourseVm.rangeType == GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createCourseVm.periodsArray) {
          var temp = {
            periodId: createCourseVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        courses.periods = arrayPeriod
      } else {
        courses.startDate = createCourseVm.startDate
        courses.endDate = createCourseVm.endDate
      }

      addOrEditcourses(courses)
    }

    function addOrEditcourses (courses) {
      WorkPlanSrv.addCourseExtern.save(courses).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getNotify(courses.origin)
          confirmCourseAction()
        } else {
          createCourseVm.disableSaveButton = false
          console.log('Error Comunications')
        }
      })
    }

    function close () {
      return $mdDialog.hide()
    }

    function changeTypeInstitution () {
      createCourseVm.searchText = null
    }

    function getNotify (origin) {
      /* let reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.consolidation)
      if(reviewers) */
      getSendNotify(origin)
    }

    function getSendNotify (origin) {
      let msg = 'El curso externo registrado por el profesor' + post.name + ' requiere su verificación y validación.'
      let data = {
        dsName: 'Notificación, se agregó o editó un curso externo',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1
      }
      GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then(
        function (dataReturn) {
          console.log(dataReturn)
        }, function (data) {
        console.log(data)
      })
    }
  }// Fin del constructor

  rbPlanifications (bool) {
    if (bool) {
      this.startDate = null
      this.endDate = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.startDate = null
      this.endDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateCourseCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/createCourse/createCourseCtrl.js